import { render, staticRenderFns } from "./PageTwelve.vue?vue&type=template&id=4e5c1c24&scoped=true"
import script from "./PageTwelve.vue?vue&type=script&lang=js"
export * from "./PageTwelve.vue?vue&type=script&lang=js"
import style0 from "./PageTwelve.vue?vue&type=style&index=0&id=4e5c1c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c1c24",
  null
  
)

export default component.exports